import { makeAutoObservable } from 'mobx';

class CreditStore {
  constructor() {
    makeAutoObservable(this);
  }

  public credits: [] | null = null;
  public isLoading = false;

  public setCredits(credits: []) {
    this.credits = credits;
  }

  public setLoading(loading: boolean) {
    this.isLoading = loading;
  }
}

export const creditStore = new CreditStore();
